<div class="row">
  <div class="col-xs-12">
    <h4>{{ 'SILOREAL_CREDENTIALS.TITLE'|translate }}</h4>
    <p>{{ 'SILOREAL_CREDENTIALS.DESCRIPTION'|translate }}</p>
  </div>
</div>

<ng-container *ngIf="!loading; else loadingSpinner">
  <div class="row">
    <div class="col-sm-6">
      <form #credentialsForm="ngForm" (ngSubmit)="save(credentialsForm)" id="silo-credentials-form">
        <!-- Username -->
        <div class="form-group">
          <label class="control-label" for="silo-username">
            {{ 'SILOREAL_CREDENTIALS.USERNAME'|translate }}
          </label>
          <input
            type="text"
            id="silo-username"
            name="username"
            class="form-control"
            [(ngModel)]="credentials.username"
            [disabled]="processing"
            required
            maxlength="128"
            autocomplete="off">
        </div>

        <!-- Password -->
        <div class="form-group">
          <label class="control-label" for="silo-password">
            {{ 'SILOREAL_CREDENTIALS.PASSWORD'|translate }}
          </label>
          <div class="input-group">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="silo-password"
              name="password"
              class="form-control"
              [(ngModel)]="credentials.password"
              [disabled]="processing"
              [required]="!credentials.has_password"
              [placeholder]="credentials.has_password ? '••••••••' : ''"
              maxlength="128"
              autocomplete="new-password">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default" (click)="togglePasswordVisibility()" [disabled]="processing">
                <span class="material-symbols-rounded">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </span>
          </div>
          <span class="help-block" *ngIf="credentials.has_password">
            {{ 'SILOREAL_CREDENTIALS.PASSWORD_KEEP_HINT'|translate }}
          </span>
        </div>

        <!-- Success message -->
        <div class="alert alert-success" *ngIf="saved">
          {{ 'SILOREAL_CREDENTIALS.SAVED'|translate }}
        </div>

        <div class="alert alert-success" *ngIf="deleted">
          {{ 'SILOREAL_CREDENTIALS.DELETED'|translate }}
        </div>

        <!-- Error message -->
        <div class="alert alert-danger" *ngIf="error">
          {{ 'SILOREAL_CREDENTIALS.ERROR'|translate }}
        </div>

        <div class="alert alert-danger" *ngIf="deleteError">
          {{ 'SILOREAL_CREDENTIALS.DELETE_ERROR'|translate }}
        </div>

        <button
          type="submit"
          form="silo-credentials-form"
          class="btn btn-agree"
          [disabled]="!credentialsForm.valid || processing">
          {{ 'SILOREAL_CREDENTIALS.SAVE'|translate }}
        </button>

        <!-- Solo se puede eliminar si hay credenciales guardadas -->
        <button
          *ngIf="credentials.has_password"
          type="button"
          class="btn btn-link text-danger"
          [disabled]="processing"
          (onConfirm)="delete(credentialsForm)"
          [confirm-options]="{
            body: 'SILOREAL_CREDENTIALS.DELETE_CONFIRM'|translate,
            action: 'GLOBAL.YES_DELETE'|translate
          }">
          {{ 'SILOREAL_CREDENTIALS.DELETE'|translate }}
        </button>
      </form>
    </div>
  </div>
</ng-container>

<ng-template #loadingSpinner>
  <div class="loading">
    <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
  </div>
</ng-template>
